<!-- DealUserSearch -->

<template>
  <el-select
    filterable
    remote
    clearable
    :disabled="id != undefined && id == 'set_as_merchant_supervisor'"
    :remote-method="loadTicketUserList"
    v-model="ticketUser.id"
    @clear="onClear"
    @focus="onFocus"
    @change="onChange"
    @visible-change="onVisibleChange"
    placeholder="用手机号/账号/昵称搜索"
    :style="css">
    <el-option v-for="item in ticketUserList"
      :key="item.id"
      :label="item.label"
      :value="item.id"></el-option>
  </el-select>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';

export default {
  name: "DealUserSearch",

  props: ["css", 'userId', 'value','id'],

  data() {
    return {
      ticketUser : {},
      ticketUserList : []
    };
  },

  watch : {
    userId( _new, _old ) {
      // console.log('#32', _old, ">", _new, 'uid=', this.ticketUser.id);

      if ( _new == _old ) {
        return;
      }

      this.onUserIdChange();
    },

    value() {
      this.onValueChange();
    } 
  },

  methods : {
    onVisibleChange() {
      setTimeout(() => {
        $('div.el-select-dropdown.el-popper').css('z-index', 20000);
      }, 100);
    },

    onValueChange() {
      // console.log('#55 DealUserSearch.onValueChange', this.value, this);

      this.setUserId(this.value);
      this.$forceUpdate();
    },

    onUserIdChange() {
      // console.log('#60 onUserIdChange', this.userId, this);

      this.setUserId(this.userId);
    },

    clearValue() {
      this.ticketUser = {}; // 清空
    },

    setUserId( _id ) {
      // console.log('#82 setUserId', this.userId, _id, this);

      if(!_id || "" == _id){
        return;
      }

      var _this = this;
      sdk.TicketUserApi().findById({
        id: _id
      }).then(res => {
        if( !res ) {
          return;
        }

        _this.ticketUser = this.userWithLabel(res);
        _this.ticketUserList = [_this.ticketUser];
      });
    },

    onFocus() {
      // console.log('#78 onFocus', this);

      var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
      var _ticketUserList = JSON.parse( _val );
      this.ticketUserList = this.userDistinct_0(_ticketUserList);
    },

    setValue( _user ) {
      // console.log('#86 setValue', _user, this);

      if ( !_user ) {
        return;
      }

      this.ticketUser = this.userWithLabel(_user);
    },

    setList( _list ) {
      // console.log('#110 setList', _list, this);

      this.ticketUserList = _list;
    },

    // 获取用户列表
    loadTicketUserList( _query ) {
      // console.log('#110 loadTicketUserList', _query, this);

      var _this = this;
      sdk.TicketUserApi().search({
        key: _query
      }).then(res => {
        if( !res ) {
          return;
        }

        _this.ticketUserList = res.map(_this.userWithLabel);
      });
    },

    // 选中
    onChange( _id ) {
      var selected = this.ticketUserList.filter(e => e.id == _id);
      // console.log('#131 onChange, _id=', _id, ', selected=', selected, ', this=', this);

      var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
      var _ticketUserList = JSON.parse(_val);

      var _val2 = JSON.stringify(this.userDistinct_0(selected.concat(_ticketUserList)));
      localStorage.setItem(CacheUtil.TicketUserListCache, _val2);

      this.$emit('input', _id); // input 在 change 前
      this.$emit("change", _id);
    },

    onClear() {
      // console.log('#160 onClear', this);
      this.ticketUser = {}; // 清空

      this.$emit('input', null); // input 在 change 前
      this.$emit("change", null);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/DealUserSearch.vue